import { Component } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'smart-dropdown-user',
  templateUrl: './dropdown-user.component.html',
  styleUrls: ['./dropdown-user.component.css'],
})
export class DropdownUserComponent {
  urlupload = environment.URLUPLOAD
  user = {
    avatar: sessionStorage.getItem("profile_img") !== 'null' ? sessionStorage.getItem("profile_img") : null,
    username: sessionStorage.getItem("username"),
    displayname: sessionStorage.getItem("display_name")
  };
  constructor(

    private authenticationService: AuthenticationService, private router: Router
  ) { 
    // console.log("!@#!@#!@#!@#!@#!@#!@#!@#",sessionStorage.getItem("display_name"))
  }
 

  public async logout() {
    setTimeout(async () => {
      sessionStorage.clear();
      window.location.href = `${environment.GATEWAY_URL}/platform-logout`;
    },1000);
  }

}
